const DropdownHead = ({ label, isFold, foldLabel, isActive, onClick }) => {
  return (
    <div
      onClick={onClick}
      className={`
        p-3 font-bold flex justify-between items-center cursor-pointer md:cursor-default 
        ${isActive ? "text-blue-600 bg-blue-50 border-b border-blue-100" : "text-slate-500"}
      `}
    >
      <span>{label}</span>
      {/* 접혀있을 때 선택된 값 보여주기 */}
      {isFold && <span className="text-xs text-blue-500 font-normal md:hidden">{foldLabel}</span>}
    </div>
  )
}

export default DropdownHead
